import { Fragment, useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import './Analyze.scss';
import Worker from 'web-worker';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleNotch, faEraser } from '@fortawesome/free-solid-svg-icons';
import { Tooltip } from 'react-tooltip'

let worker;

const identicals = [
  [1, 10, 19, 28, 37],
  [2, 11, 20, 29, 38],
  [3, 12, 21, 30, 39],
  [4, 13, 22, 31, 40],
  [5, 14, 23, 32, 41],
  [6, 15, 24, 33, 42],
  [7, 16, 25, 34, 43],
  [8, 17, 26, 35, 44],
  [9, 18, 27, 36, 45]
];

const Analyze = (props) => {
  const keyNumbers = useSelector((state) => state.analyze.keyNumbers);
  const [keyNumbersForUse, setKeyNumbersForUse] = useState([]);
  const draws = useSelector((state) => state.app.data);
  const [previousDrawsCount, setPreviousDrawsCount] = useState(0);
  const [previousDrawsNumbers, setPreviousDrawsNumbers] = useState([]);
  const [processing, setProcessing] = useState(false);
  const [drawsOfInterestFromAnalyze, setDrawsOfInterestFromAnalyze] = useState([]);
  const [numberExceptions, setNumberExceptions] = useState([]);
  const [numbersForSearch, setNumbersForSearch] = useState([]);
  const [progress, setProgress] = useState(0);
  const [whiteNumbers, setWhiteNumbers] = useState([]);
  const [whiteNumbersDistances, setWhiteNumbersDistances] = useState({});
  const [filterDrawsFromAnalyzeByWhiteNumbers, setFilterDrawsFromAnalyzeByWhiteNumbers] = useState(false);
  const [tableViewType, setTableViewType] = useState(2);
  const [searchByWhiteNumbersCount, setSearchByWhiteNumbersCount] = useState('');
  const [previous6DrawsNumbers, setPrevious6DrawsNumbers] = useState([]);
  const [whiteNumbersIdenticals, setWhiteNumbersIdenticals] = useState([]);
  const [last2Numbers, setLast2Numbers] = useState([]);
  const [filterByRecommendedWhiteNumbers, setFilterByRecommendedWhiteNumbers] = useState(false);
  const [currentDistancesRaw, setCurrentDistancesRaw] = useState([]);
  const [currentDistances, setCurrentDistances] = useState(null);
  const [distancesSelected, setDistancesSelected] = useState([]);
  const [dateFilterFrom, setDateFilterFrom] = useState('');
  const [dateFilterTo, setDateFilterTo] = useState('');
  const normalViewTypeTableElRef = useRef(null);
  const secondViewTypeTableElRef = useRef(null);

  const navigate = useNavigate();

  useEffect(() => {
    if (keyNumbers.length === 0) {
      navigate('/');
    } else {
      setKeyNumbersForUse(keyNumbers);
    }

    const localDateFilterFrom = localStorage.getItem('date-filter-from');

    if (localDateFilterFrom !== null && localDateFilterFrom.length > 0) {
      setDateFilterFrom(localDateFilterFrom);
    }

    const localDateFilterTo = localStorage.getItem('date-filter-to');

    if (localDateFilterTo !== null && localDateFilterTo.length > 0) {
      setDateFilterTo(localDateFilterTo);
    }

    return () => {
      if (worker) {
        worker.terminate();
      }
    };
  }, []);

  useEffect(() => {
    if (draws.length > 0) {
      if (worker) {
        worker.terminate();
      }

      worker = new Worker(
        new URL('../../worker.js', import.meta.url),
        { type: 'module' }
      );

      worker.addEventListener('message', e => {
        if (e.data.type === 'draws-of-interest') {
          let _drawsOfInterestFromAnalyze = e.data.value;

          // if (distancesSelected.length > 0) {

          //   function groupSimilarArrays(data, similarityThreshold = 2) {
          //     const groups = [];
          
          //     // Helper function to find common elements between two arrays
          //     function getCommonCount(arr1, arr2) {
          //         const set1 = new Set(arr1);
          //         return arr2.filter(num => set1.has(num)).length;
          //     }
          
          //     // Iterate over each array in the data
          //     data.forEach((currentArray) => {
          //         let addedToGroup = false;
          
          //         // Check if it can be added to an existing group
          //         for (const group of groups) {
          //             if (getCommonCount(group[0], currentArray) >= similarityThreshold) {
          //                 group.push(currentArray);
          //                 addedToGroup = true;
          //                 break;
          //             }
          //         }
          
          //         // If not added to any group, create a new group
          //         if (!addedToGroup) {
          //             groups.push([currentArray]);
          //         }
          //     });
          
          //     return groups;
          //   }
          
          //   const groups = groupSimilarArrays(e.data.value.map((d) => {
          //     d.winningNumbers.list.draw = d;

          //     return d.winningNumbers.list;
          //   }));
            
          //   groups.forEach((group, i) => {
          //     group.forEach((array, j) => {
          //       groups[i][j] = array.draw;
          //     });
          //   });

          //   console.log(groups)

          //   _drawsOfInterestFromAnalyze = [];

          //   groups.forEach((group) => {
          //     group.forEach((draw) => {
          //       _drawsOfInterestFromAnalyze.push(draw);
          //     });
          //   });
          // }
          
          setDrawsOfInterestFromAnalyze(_drawsOfInterestFromAnalyze);
        } else if (e.data.type === 'info') {
          switch (e.data.value) {
            case 'processing':
              setProcessing(true);
              break;
            case 'finished':
              setProcessing(false);
              break;
            case 'progress':
              setProgress(e.data.data);
              break;
          }
        }
      });

      startAnalyze();

      const drawIndex = draws.findIndex((d) => d.winningNumbers.list.every((n) => keyNumbers.includes(n)));
      
      if (drawIndex > -1) {
        const draw = draws[drawIndex];
        const previousDraws = draws.filter((d) => d.date < draw.date);
        const drawsOfInterest = findDrawsOfInterest(draw, previousDraws);
        const wn = calculateWhiteNumbers(draw.winningNumbers.list, previousDraws[0].winningNumbers.list, drawsOfInterest);
        setWhiteNumbers(wn);

        const wnd = {};
        wn.forEach((number) => {
          let distance;

          for (let i = 0; i < previousDraws.length; i++) {
            const draw = previousDraws[i];

            if (draw.winningNumbers.list.includes(number)) {
              distance = i + 1;
              break;
            }
          }

          wnd[number] = distance;
        });
        setWhiteNumbersDistances(wnd);

        // numbers from 6 previous draws
        let p6dn = [];
        previousDraws.slice(1, 7).forEach((draw) => {
          p6dn = [...p6dn, ...draw.winningNumbers.list];
        });
        setPrevious6DrawsNumbers(p6dn);

        // white numbers which are identicals with current draw numbers
        let wni = [];
        draw.winningNumbers.list.forEach((number) => {
          const identicalsGroup = identicals.find((g) => g.includes(number));
          let whiteNumbersIdenticals = wn.filter((n) => identicalsGroup.includes(n));
          wni = [
            ...wni,
            ...whiteNumbersIdenticals.filter((n, k) => whiteNumbersIdenticals.indexOf(n) === k),
          ];
        });
        wni = wni.filter((n, k) => wni.indexOf(n) === k);
        setWhiteNumbersIdenticals(wni);

        // last two numbers from all possible pairs (of draw winning numbers)
        const getPairsOfNumbers = (arr) => arr.map( (v, i) => arr.slice(i + 1).map(w => [v, w]) ).flat();
        const pairs = getPairsOfNumbers(draw.winningNumbers.list);
        let l2n = [];
        pairs.forEach((pair) => {
          const drawsOfInterest = previousDraws.filter((draw) => {
            return draw.winningNumbers.list.filter((n) => pair.includes(n)).length >= 2;
          });
          
          drawsOfInterest.forEach((draw) => {
            const keys = draws[0].winningNumbers.list;
            const keyAppears = draw.winningNumbers.list.filter((n) => keys.includes(n) && !pair.includes(n)).length >= 1;
            if (keyAppears) {
              l2n = [
                ...l2n,
                ...draw.winningNumbers.list.filter((n) => !keys.includes(n) && !pair.includes(n)),
              ];
            }
          });
        });
        l2n = l2n.filter((n, k) => l2n.indexOf(n) === k);
        setLast2Numbers(l2n);
      }
    }
  }, [draws.length]);

  useEffect(() => {
    if (keyNumbers.length === 5 && draws.length > 0) {
      setCurrentDistances(calculateCurrentDistances());
    }
  }, [keyNumbers, draws.length]);
  
  useEffect(() => {
    if (draws.length > 0 && keyNumbersForUse.length > 0) {
      if (worker) {
        startAnalyze();
      }
    }
  }, [
    keyNumbersForUse,
    numberExceptions,
    numbersForSearch,
    filterDrawsFromAnalyzeByWhiteNumbers,
    searchByWhiteNumbersCount,
    filterByRecommendedWhiteNumbers,
    distancesSelected,
    dateFilterFrom,
    dateFilterTo,
  ]);

  useEffect(() => {
    setTimeout(() => {
      if (tableViewType == 1) {
        normalViewTypeTableElRef.current.parentNode.scrollTop = 0;
      } else if (tableViewType == 2) {
        secondViewTypeTableElRef.current.parentNode.scrollTop = secondViewTypeTableElRef.current.parentNode.scrollHeight;
      }
    });
  }, [drawsOfInterestFromAnalyze]);

  useEffect(() => {
    let pdn = []; // previous draws numbers

    draws.slice(0, parseInt(previousDrawsCount)).forEach((draw) => {
      pdn = [...pdn, ...draw.winningNumbers.list]
    });

    pdn = pdn.filter((number, i) => pdn.indexOf(number) === i);
    setPreviousDrawsNumbers(pdn);
  }, [previousDrawsCount]);

  const startAnalyze = () => {
    worker.postMessage({
      action: 'analyze',
      keys: keyNumbersForUse,
      data: draws,
      numberExceptions,
      numbersForSearch,
      filterByWhiteNumbers: filterDrawsFromAnalyzeByWhiteNumbers,
      searchByWhiteNumbersCount,
      whiteNumbers,
      filterByRecommendedWhiteNumbers,
      last2Numbers,
      previous6DrawsNumbers,
      whiteNumbersIdenticals,
      currentDistances,
      distancesSelected,
      dateFilterFrom,
      dateFilterTo,
    });
  };

  function findDrawsOfInterest(draw, draws) {
    const result = [];

    draws.forEach((d) => {
      const identicalNumbersCount = d.winningNumbers.list.filter((n) => draw.winningNumbers.list.includes(n)).length;
      if (identicalNumbersCount >= 3) {
        result.push(d);
      }
    });

    return result;
  }

  function calculateWhiteNumbers(numbers, keys, drawsOfInterest) {
    keys = keys.slice();
    for (let i = 0; i < keys.length; i++) {
      if (numbers.includes(keys[i])) {
        keys.splice(i--, 1);
      }
    }

    const whiteNumbersFromDraws = [];
    drawsOfInterest.forEach((draw) => {
      whiteNumbersFromDraws.push(draw.winningNumbers.list.filter((n) => !keys.includes(n) && !numbers.includes(n)));
    });

    let result = [];
    whiteNumbersFromDraws.forEach((numbers) => {
      result = [...result, ...numbers];
    });

    return result;
  }

  const calculateCurrentDistances = () => {
    const numberDistances = [];

    const numbers = Array.from(Array(45)).map((n, index) => {
      return {
        value: index + 1,
        distance: 0,
      };
    });

    let drawIndex = -1;

    for (let i = 0; i < draws.length; i++) {
      let isSame = true;

      for (let j = 0; j < keyNumbers.length; j++) {
        isSame &= keyNumbers[j] === draws[i].winningNumbers.list[j];

        if (!isSame) {
          break;
        }
      }

      if (isSame) {
        drawIndex = i;

        break;
      }
    }

    if (drawIndex > -1) {
      const previousDraws = draws.slice(drawIndex);

      for (let i = 0; i < previousDraws.length; i++) {
        for (let j = 0; j < numbers.length; j++) {
          if (previousDraws[i].winningNumbers.list.includes(numbers[j].value)) {
            numberDistances.push(numbers.splice(j--, 1)[0]);
          }
        }

        numbers.forEach((number) => number.distance++);
  
        if (numbers.length === 0) {
          break;
        }
      }

      setCurrentDistancesRaw(numberDistances);

      const distances = {};

      for (let i = 0; i < numberDistances.length; i++) {
        distances[numberDistances[i].distance] = distances[numberDistances[i].distance] || [];
        
        distances[numberDistances[i].distance].push(numberDistances[i].value);
      }

      return distances;
    }

    return null;
  };

  const toggleKeyNumber = (number) => {
    const newKeyNumbersForUse = keyNumbersForUse.slice();

    if (keyNumbersForUse.includes(number)) {
      newKeyNumbersForUse.splice(newKeyNumbersForUse.indexOf(number), 1)
    } else {
      newKeyNumbersForUse.push(number);
    }

    setKeyNumbersForUse(newKeyNumbersForUse);
  };

  const toggleNumberException = (number) => {
    const newNumberExceptions = numberExceptions.slice();

    if (numberExceptions.includes(number)) {
      newNumberExceptions.splice(newNumberExceptions.indexOf(number), 1)
    } else {
      newNumberExceptions.push(number);
    }

    setNumberExceptions(newNumberExceptions);
  };

  const toggleNumberForSearch = (number) => {
    const newNumbersForSearch = numbersForSearch.slice();

    if (numbersForSearch.includes(number)) {
      newNumbersForSearch.splice(newNumbersForSearch.indexOf(number), 1)
    } else {
      newNumbersForSearch.push(number);
    }

    setNumbersForSearch(newNumbersForSearch);
  };

  const currentDistancesArray = currentDistancesRaw.map((d) => d.distance);
  const currentDistancesValues = currentDistancesRaw.map((d) => d.value);

  function YearSelect({ draws }) {
    if (!draws || draws.length === 0) {
      return <p>No draws available</p>;
    }

    // Extract min/max years (array is sorted DESC)
    const maxYear = new Date(draws[0].date).getUTCFullYear();
    const minYear = new Date(draws[draws.length - 1].date).getUTCFullYear();

    // Build range of years
    const years = [];
    for (let y = minYear; y <= maxYear; y++) {
      years.push(y);
    }

    return (
      <Fragment>
        <select value={dateFilterFrom} onChange={(e) => {
          localStorage.setItem('date-filter-from', e.target.value);
          setDateFilterFrom(e.target.value);
        }}>
          <option value="">Από</option>
          {years.map((year) => (
            <option key={year} value={year}>
              {year}
            </option>
          ))}
        </select>
        &nbsp;
        <select value={dateFilterTo} onChange={(e) => {
          localStorage.setItem('date-filter-to', e.target.value);
          setDateFilterTo(e.target.value);
        }}>
          <option value="">Έως</option>
          {years.map((year) => (
            <option key={year} value={year}>
              {year}
            </option>
          ))}
        </select>
      </Fragment>
    );
  }

  return (
    <div className="Analyze">
      <div className="panel">
        <div className="details">
          <div className="key-numbers">
            {
              keyNumbers.map((n, i) => {
                return (
                  <div
                    key={i}
                    className={`${keyNumbersForUse.includes(n) ? 'active' : ''}`}
                    onClick={toggleKeyNumber.bind(this, n)}
                  >{n}</div>
                );
              })
            }
          </div>

          <div className="draws-of-interest">
            <span>Κληρώσεις ενδιαφέροντος:&nbsp;</span>
            
            {
              processing
                ? <FontAwesomeIcon icon={faCircleNotch} spin />
                : drawsOfInterestFromAnalyze.length
            }
          </div>

          <div className="numbers-tools">
            <div className="number-exceptions">
              <span className="label">Εξαιρέσεις Αριθμών</span>
              <div className="numbers">
                {
                  Array.from(Array(45)).map((n, i) => {
                    if (keyNumbersForUse.includes(i + 1)) {
                      return;
                    }

                    return (
                      <div
                        key={i}
                        className={`${numberExceptions.includes(i + 1) ? 'active' : ''}`}
                        onClick={toggleNumberException.bind(this, i + 1)}
                      >
                        {i + 1}
                      </div>
                    );
                  })
                }
              </div>
            </div>

            <div className="numbers-for-search">
              <span className="label">Αναζήτηση Αριθμών</span>
              <div className="numbers">
                {
                  Array.from(Array(45)).map((n, i) => {
                    if (keyNumbersForUse.includes(i + 1) || numberExceptions.includes(i + 1)) {
                      return;
                    }

                    return (
                      <div
                        key={i}
                        className={`${numbersForSearch.includes(i + 1) ? 'active' : ''}`}
                        onClick={toggleNumberForSearch.bind(this, i + 1)}
                      >
                        {i + 1}
                      </div>
                    );
                  })
                }
              </div>
            </div>
          </div>

          <div>
            <span>Χρονικός κόφτης</span>
            &nbsp;
            {
              YearSelect({ draws })
            }
          </div>

          <div className="mark-previous-draws-numbers">
            <span>Σημείωση αριθμών απο</span>
            <input type="number" value={previousDrawsCount} onChange={(e) => {
              const value = e.target.value;
              if (value >= 0) {
                setPreviousDrawsCount(e.target.value)
              }
            }}
            />
            <span>{previousDrawsCount > 1 ? 'προηγούμενες κληρώσεις' : 'προηγούμενη κλήρωση'}</span>
          </div>

          <div style={{ marginTop: '30px' }}>
            <span>Φίλτρο λευκών αριθμών</span>
            <input
              type="checkbox"
              value={filterDrawsFromAnalyzeByWhiteNumbers}
              onChange={(e) => {
                setFilterDrawsFromAnalyzeByWhiteNumbers(e.target.checked);
              }}
            />
          </div>
          <div style={{ marginTop: '10px' }}>
            <span>Πλήθος λευκών αριθμών</span>
            &nbsp;
            <input
              type="number"
              min={0}
              max={4}
              value={searchByWhiteNumbersCount}
              onChange={(e) => {
                setSearchByWhiteNumbersCount(e.target.value);
              }}
            />
          </div>

          <div style={{ marginTop: '30px' }}>
            <span>Φίλτρο υπόλοιπων λευκών αριθμών</span>
            <input
              type="checkbox"
              value={filterByRecommendedWhiteNumbers}
              onChange={(e) => {
                setFilterByRecommendedWhiteNumbers(e.target.checked);
              }}
            />
          </div>

          <select
            style={{ marginTop: '30px' }}
            value={tableViewType}
            onChange={(e) => {
              setTableViewType(e.target.value);
            }}
          >
            <option value="1">Κανονική Προβολή</option>
            <option value="2">Ομαδοποιημένη Προβολή</option>
          </select>

          <div className={`current-distances${currentDistances !== null ? '' : ' d-none'}`}>
            <span>Aποστάσεις:</span>

            {
              currentDistances !== null && Object.keys(currentDistances).map((distance, i) => {
                const dn = currentDistances[distance]; // distance numbers
                const indexInDistancesSelected = distancesSelected.indexOf(distance);

                return (
                  <div
                    key={i}
                    className={`distance${indexInDistancesSelected > -1 ? ' selected' : ''}`}
                    data-tooltip-id={`distance-${distance}-numbers`}
                    data-tooltip-content={`Αριθμ${dn.length > 1 ? 'οί:' : 'ός'} ${dn.join(', ')}`}
                    data-tooltip-place="top"
                    onClick={() => {
                      const ds = distancesSelected.slice();

                      if (indexInDistancesSelected > -1) {
                        ds.splice(indexInDistancesSelected, 1);
                      } else {
                        ds.push(distance);
                      }

                      setDistancesSelected(ds);
                    }}
                  >
                    {parseInt(distance) + 1}

                    <Tooltip id={`distance-${distance}-numbers`} />
                  </div>
                );
              })
            }

            <button
              data-tooltip-id="btn-clear-selected-distances"
              data-tooltip-content="Αποεπιλογή επιλεγμένων αποστάσεων"
              data-tooltip-place="top"
              onClick={() => {
                setDistancesSelected([]);
              }}
            >
              <FontAwesomeIcon icon={faEraser}></FontAwesomeIcon>
              <Tooltip id="btn-clear-selected-distances" />
            </button>
          </div>
        </div>

        <div className="table">
          {
            processing && <span style={{ display: 'flex', padding: '40px' }}>Επεξεργασία φίλτρων</span>
          }

          <table ref={secondViewTypeTableElRef} className={`draws-of-interest-second-view-type ${!processing && tableViewType == 2 ? '' : 'd-none'}`}>
            <thead>
              <tr>
                <th></th>
                <th>1</th>
                <th>2</th>
                <th>3</th>
                <th>4</th>
                <th>5</th>
                <th>6</th>
                <th>7</th>
                <th>8</th>
                <th>9</th>
                <th>0</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {
                drawsOfInterestFromAnalyze.sort((a, b) => a.date > b.date ? 1 : -1).map((draw, i) => {
                  return (
                    <tr key={draw.id} data-draw-id={draw.id}>
                      <td className="date" style={{ padding: '0 3px' }}>{moment(draw.date).format('D-M-YYYY')}</td>
                      {
                        Array.from(Array(10)).map((n, k) => {
                          return (
                            <td key={k}>
                              {
                                draw.winningNumbers.list.filter((number) => number % 10 === (k + 1) % 10).map((number, j) => {
                                  const distance = currentDistancesArray[currentDistancesValues.indexOf(number)];

                                  return (
                                    <div
                                      key={j}
                                      className={`
                                        ${!keyNumbersForUse.includes(number) && previousDrawsNumbers.includes(number) ? 'previous-draw-number' : ''}
                                        ${keyNumbersForUse.includes(number) ? 'key' : ''}
                                        ${numbersForSearch.includes(number) ? 'highlight' : ''}
                                        ${filterDrawsFromAnalyzeByWhiteNumbers && whiteNumbers.includes(number) ? 'white-number' : ''}
                                        ${filterByRecommendedWhiteNumbers && last2Numbers.includes(number) && (whiteNumbersIdenticals.includes(number)) ? 'recommended-white-number' : ''}
                                      `}
                                      title={`Απόσταση: ${distance + 1}`}
                                    >
                                      {number}
                                    </div>
                                  );
                                })
                              }
                            </td>
                          );
                        })
                      }
                      <td className="bonus">{draw.winningNumbers.bonus[0]}</td>
                    </tr>
                  );
                })
              }
            </tbody>
          </table>

          <table ref={normalViewTypeTableElRef} className={`draws-of-interest ${!processing && tableViewType == 1 ? '' : 'd-none'}`}>
            <tbody>
              {
                drawsOfInterestFromAnalyze.reverse().map((draw, i) => {

                  return (
                    <tr key={i}>
                      <td className="date">{moment(draw.date).format('D-M-YYYY')}</td>
                      {
                        draw.winningNumbers.list.map((number, j) => {
                          return (
                            <td
                              key={j}
                              className={`${!keyNumbersForUse.includes(number) && previousDrawsNumbers.includes(number) ? 'previous-draw-number' : ''} ${keyNumbersForUse.includes(number) ? 'key' : ''} ${numbersForSearch.includes(number) ? 'search-number' : ''} ${whiteNumbers.includes(number) ? 'white-number' : ''}`}
                            >
                              <span className="distance">{whiteNumbersDistances[number]}</span>
                              {number}
                            </td>
                          );
                        })
                      }
                      <td className="bonus">{draw.winningNumbers.bonus[0]}</td>
                    </tr>
                  );
                })
              }
            </tbody>
          </table>
        </div>
      </div>

      <div
        className="draws-of-interest-count"
        data-tooltip-id='draws-of-interest-count'
        data-tooltip-content="Κληρώσεις ενδιαφέροντος"
      >
        {
          processing
            ? <FontAwesomeIcon icon={faCircleNotch} spin />
            : drawsOfInterestFromAnalyze.length
        }

        <Tooltip id="draws-of-interest-count" />
      </div>
    </div>
  );
}

export default Analyze;
